import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal, Tabs } from 'antd'
import WrappedCoinUpdate from '../UpdateCoin'


const CoinForm = (props) => {
  const { visible, onOk, onCancel, heroId , coin } = props

  return (
    <Modal
      destroyOnClose={true}
      title="Update Coin"
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Tabs type="card" defaultActiveKey="1">
        <Tabs.TabPane tab="Update Coin" key="1">
          <WrappedCoinUpdate
            onOk={onOk}
            onCancel={onCancel}
            heroId={heroId}
            coin={coin}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

CoinForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default CoinForm



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/Coin/components/UpdateCoinForm/index.js